import React from 'react';
import { HiCheckCircle } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';
import { Button, Copy, Image, Title } from '#components/atoms';
import { checkList } from '#mocks/statistics';

export const ExperienceImprove = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-5 lg:mx-24 md:pt-2 md:pb-7 lg:py-8 md:flex md:flex-col overflow-hidden">
      <Copy className="!text-base lg:!text-xl !font-bold !text-blue-400 mb-2 md:mb-5 lg:text-center 2xl:!text-2xl">
        Mejora tu experiencia
      </Copy>
      <Title className="!text-3xl mb-8 lg:mb-12 lg:text-center lg:!text-5xl 2xl:!text-6xl 2xl:mb-12">
        Activa estadísticas exclusivas en Bilog
      </Title>
      <div className="lg:grid lg:grid-cols-12">
        <div className="my-10 lg:col-span-6">
          <Copy className="!text-base mb-12 lg:text-start lg:!text-xl lg:mt-16">
            Nuestra sección de <strong>estadísticas</strong> te permite conocer
            métricas especializadas y personalizadas para tu consultorio,
            facilitando estrategias adaptadas a tu negocio y favoreciendo su
            crecimiento.
          </Copy>
          {checkList?.map((item, index) => (
            <div className="flex items-center gap-x-4 mx-2 my-5" key={index}>
              <HiCheckCircle className="text-blue-500 size-8" />
              <Copy className="!text-xl 2xl:!text-2xl w-full">{item}</Copy>
            </div>
          ))}
          <div className="w-full lg:flex lg:gap-x-6 lg:mt-10">
            <Button
              onClick={() =>
                window.open('https://payments.bilog.com.ar', '_self')
              }
              className="w-full mb-4"
            >
              Accede a tarifas
            </Button>
            <Button className="w-full" modifier="white">
              Contáctanos
            </Button>
          </div>
        </div>
        <div className="w-full flex justify-center lg:col-span-5 lg:col-start-8">
          <Image
            src={require(`#assets/products/statistics-experience.png`)}
            width={400}
            height={300}
            alt="product-image"
          />
        </div>
      </div>
    </div>
  );
};
